import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Check } from "lucide-react";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); setOrder(data); clear(); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("failed"); return; }
      } catch { /* retry */ }
      if (tries++ < 8) setTimeout(poll, 2000); else setStatus("pending");
    };
    poll();
  }, [sessionId]); // eslint-disable-line

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-20 text-center" data-testid="payment-success-page">
      <div className="max-w-md">
        {status === "checking" && <p className="font-heading text-3xl text-ink/50">Confirming your payment…</p>}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 rounded-full bg-ink text-linen flex items-center justify-center mx-auto mb-6"><Check size={28} strokeWidth={1.5} /></div>
            <h1 className="font-heading text-4xl md:text-5xl tracking-tight mb-3">Thank You</h1>
            <p className="font-body text-sm text-ink/70 mb-2">Your voyage is on its way.</p>
            {order?.order_number && <p className="font-body text-sm">Order <b data-testid="success-order-number">{order.order_number}</b></p>}
            <div className="flex gap-3 justify-center mt-8">
              <Link to="/account" className="btn-primary">View My Orders</Link>
              <Link to="/shop" className="btn-outline">Keep Shopping</Link>
            </div>
          </>
        )}
        {(status === "pending" || status === "checking") === false && status === "pending" && (
          <p className="font-heading text-2xl text-ink/60">Payment is processing. Check your account shortly.</p>
        )}
        {status === "failed" && <><h1 className="font-heading text-4xl mb-3">Payment Not Completed</h1><Link to="/checkout" className="btn-primary mt-4">Try Again</Link></>}
        {status === "error" && <p className="font-heading text-2xl text-ink/60">Missing payment reference.</p>}
      </div>
    </div>
  );
}
